/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/motivo-baja'

export default {
    get: params =>{ Api().get(route, { params, crossDomain: true }); console.log(`Entrooooooooo ${params.filter}`)} ,
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: expand => Api().get(`${route}?${expand}`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=status_description`)
}